import { pb } from '@/libs/pocketbase'
import { tryCatch } from '@/utils/try-catch'
import { defaultUserPreferences } from '../domain/user-preferences'
import type { UserPreferences, UserPreferencesPort, UserPreferencesUpdate } from '../domain/user-preferences'

const normalizePreferences = (preferences: UserPreferences): UserPreferences => ({ ...defaultUserPreferences, ...preferences })

const pbUserPreferences: UserPreferencesPort = {
	get: async (): Promise<UserPreferences> => {
		const result = await tryCatch(pb.send<UserPreferences>('/api/preferences', { method: 'GET', requestKey: null }))
		if (!result.isSuccess) throw new Error(result.error.message)
		return normalizePreferences(result.data)
	},

	update: async (patch: UserPreferencesUpdate): Promise<UserPreferences> => {
		const result = await tryCatch(
			pb.send<UserPreferences>('/api/preferences', {
				method: 'PATCH',
				body: JSON.stringify(patch),
				headers: { 'Content-Type': 'application/json' },
				requestKey: null,
			}),
		)
		if (!result.isSuccess) throw new Error(result.error.message)
		return normalizePreferences(result.data)
	},
}

export { pbUserPreferences }
